import { SchoolService, BaseService } from "@/services/school.service";
import moment from "moment";

function ReportingFilter(calendar, years, group, types, tags, includePupilTags, date, crew) {
    this.calendar = calendar;
    this.years = years;
    this.group = group;
    this.tags = tags;
    this.types = types
    this.includePupilTags = includePupilTags
    this.date = date;
    this.crew = crew
}

const ReportingService = {

    getAssessmentsWithFilter(filterValues, page, pageSize) {

        // calendar
        let cal = filterValues.calendar.value

        // group
        let group = (filterValues.group != undefined && filterValues.group.id > 0) ? "&class=" + filterValues.group.name.toLowerCase() : ""

        // years
        let years = filterValues.years != undefined ? "&yeargroups=" + filterValues.years.join() : ""

        // types
        let types = filterValues.types != undefined ? "&types=" + filterValues.types.join() : ""

        let crew =  (filterValues.crew != undefined && filterValues.crew.id > 0) ? "&crew=" + filterValues.crew.identifier : ""

        // tags 
        var tags = ""
        if (filterValues.tags.length > 0) {
            let results = filterValues.tags.substring(0,50).replaceAll("#", "").split(' ').join(',').split(',')
            tags = "&tags=" + results
        }

        return SchoolService.getAll("reporting/curriculum?stored=" + cal + group + years + types + crew + tags + "&page=0&results_per_page=all")
    },

    getBreakdownWithFilter(filterValues, page, pageSize) {

        // calendar
        let cal = filterValues.calendar.value

        // group
        let group = (filterValues.group != undefined && filterValues.group.id > 0) ? "&class=" + filterValues.group.name.toLowerCase() : ""

        // years
        let years = filterValues.years != undefined ? "&yeargroups=" + filterValues.years.join() : ""

        // types
        let types = filterValues.types != undefined ? "&types=" + filterValues.types.join() : ""

        let crew =  (filterValues.crew != undefined && filterValues.crew.id > 0) ? "&crew=" + filterValues.crew.identifier : ""


        // tags 
        var tags = ""
        if (filterValues.tags.length > 0) {
            let results = filterValues.tags.substring(0,50).replaceAll("#", "").split(' ').join(',').split(',')
            tags = "&tags=" + results
        }

        return SchoolService.getAll("reporting/breakdown?stored=" + cal + group + years + types + crew + tags + "&page=0&results_per_page=all")
    },


    getActivities(filterValues) {
         // calendar
         let cal = filterValues.calendar.value

         // group
         let group = (filterValues.group != undefined && filterValues.group.id > 0) ? "&class=" + filterValues.group.name.toLowerCase() : ""
 
         // years
         let years = filterValues.years != undefined ? "&yeargroups=" + filterValues.years.join() : ""
 
         // types
         let types = filterValues.types != undefined ? "&types=" + filterValues.types.join() : ""
 
         let crew =  (filterValues.crew != undefined && filterValues.crew.id > 0) ? "&crew=" + filterValues.crew.identifier : ""

         // tags 
         var tags = ""
         if (filterValues.tags.length > 0) {
             let results = filterValues.tags.substring(0,50).replaceAll("#", "").split(' ').join(',').split(',')
             tags = "&tags=" + results
         }

        return SchoolService.getAll("reporting/activities?stored=" +  cal + group + years + types + crew + tags)
    },


    getEvents(filterValues) {
         // calendar
         let cal = filterValues.calendar.value

         // group
         let group = (filterValues.group != undefined && filterValues.group.id > 0) ? "&class=" + filterValues.group.name.toLowerCase() : ""
 
         // years
         let years = filterValues.years != undefined ? "&yeargroups=" + filterValues.years.join() : ""
 
         // types
         let types = filterValues.types != undefined ? "&types=" + filterValues.types.join() : ""

         let crew =  (filterValues.crew != undefined && filterValues.crew.id > 0) ? "&crew=" + filterValues.crew.identifier : ""

 
         // tags 
         var tags = ""
         if (filterValues.tags.length > 0) {
             let results = filterValues.tags.substring(0,50).replaceAll("#", "").split(' ').join(',').split(',')
             tags = "&tags=" + results
         }

        return SchoolService.getAll("reporting/events?stored=" +  cal + group + years + types + crew + tags)
    },

    getTimeline(result, calendarYear, after, before) {
        return SchoolService.getAll("reporting/pupils/" + result.identifier + "/timeline?stored=" + calendarYear + "&entry_after=" + after + "&entry_before=" + before)
    },

    getCurriculumByPupil(pupil, calendar) {
        return SchoolService.getAll("reporting/curriculum/pupils/" + pupil.identifier + "?stored=" + calendar)
    },

    getBreakdownByPupil(pupil, calendar) {
        return SchoolService.getAll("reporting/breakdown/pupils/" + pupil.identifier + "?stored=" + calendar)
    },

}

export { ReportingService, ReportingFilter };